import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.loading}}
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
{{else if this.items.length}}
  <ul aria-labelledby={{@ariaLabelledby}}>
    {{#each this.items as |item|}}
      <UserMenu::MenuItem @item={{item}} @closeUserMenu={{@closeUserMenu}} />
    {{/each}}
  </ul>
  <div class="panel-body-bottom">
    {{#if this.showAllHref}}
      <DButton
        class="show-all"
        @action={{this.showAll}}
        @translatedAriaLabel={{this.showAllTitle}}
        @translatedTitle={{this.showAllTitle}}
      >
        {{d-icon "chevron-down" aria-label=this.showAllTitle}}
      </DButton>
    {{/if}}
    {{#if this.showDismiss}}
      <button
        type="button"
        class="btn btn-default notifications-dismiss btn-icon-text"
        title={{this.dismissTitle}}
        {{on "click" this.dismissButtonClick}}
        {{auto-focus}}
      >
        {{d-icon "check"}}
        {{i18n "user.dismiss"}}
      </button>
    {{/if}}
    <PluginOutlet
      @name="panel-body-bottom"
      @outletArgs={{hash
        itemsCacheKey=this.itemsCacheKey
        closeUserMenu=@closeUserMenu
        showDismiss=this.showDismiss
        dismissButtonClick=this.dismissButtonClick
      }}
    />
  </div>
{{else}}
  <PluginOutlet
    @name="user-menu-items-list-empty-state"
    @outletArgs={{hash model=this}}
  >
    {{component this.emptyStateComponent}}
  </PluginOutlet>
{{/if}}
<PluginOutlet
  @name="after-panel-body"
  @outletArgs={{hash closeUserMenu=@closeUserMenu}}
/>
*/
{
  "id": "Z3FqFA3H",
  "block": "[[[41,[30,0,[\"loading\"]],[[[1,\"  \"],[10,0],[14,0,\"spinner-container\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"spinner\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"items\",\"length\"]],[[[1,\"  \"],[10,\"ul\"],[15,\"aria-labelledby\",[30,1]],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"items\"]]],null]],null],null,[[[1,\"      \"],[8,[39,3],null,[[\"@item\",\"@closeUserMenu\"],[[30,2],[30,3]]],null],[1,\"\\n\"]],[2]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"panel-body-bottom\"],[12],[1,\"\\n\"],[41,[30,0,[\"showAllHref\"]],[[[1,\"      \"],[8,[39,4],[[24,0,\"show-all\"]],[[\"@action\",\"@translatedAriaLabel\",\"@translatedTitle\"],[[30,0,[\"showAll\"]],[30,0,[\"showAllTitle\"]],[30,0,[\"showAllTitle\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"chevron-down\"],[[\"aria-label\"],[[30,0,[\"showAllTitle\"]]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showDismiss\"]],[[[1,\"      \"],[11,\"button\"],[24,0,\"btn btn-default notifications-dismiss btn-icon-text\"],[16,\"title\",[30,0,[\"dismissTitle\"]]],[24,4,\"button\"],[4,[38,6],[\"click\",[30,0,[\"dismissButtonClick\"]]],null],[4,[38,7],null,null],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"check\"],null]],[1,\"\\n        \"],[1,[28,[35,8],[\"user.dismiss\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"panel-body-bottom\",[28,[37,10],null,[[\"itemsCacheKey\",\"closeUserMenu\",\"showDismiss\",\"dismissButtonClick\"],[[30,0,[\"itemsCacheKey\"]],[30,3],[30,0,[\"showDismiss\"]],[30,0,[\"dismissButtonClick\"]]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"user-menu-items-list-empty-state\",[28,[37,10],null,[[\"model\"],[[30,0]]]]]],[[\"default\"],[[[[1,\"\\n    \"],[46,[30,0,[\"emptyStateComponent\"]],null,null,null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]],[]]],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"after-panel-body\",[28,[37,10],null,[[\"closeUserMenu\"],[[30,3]]]]]],null]],[\"@ariaLabelledby\",\"item\",\"@closeUserMenu\"],false,[\"if\",\"each\",\"-track-array\",\"user-menu/menu-item\",\"d-button\",\"d-icon\",\"on\",\"auto-focus\",\"i18n\",\"plugin-outlet\",\"hash\",\"component\"]]",
  "moduleName": "discourse/components/user-menu/items-list.hbs",
  "isStrictMode": false
});